import apiRequest from "./apiClient";

export async function fetchBrands() {
  const body = await apiRequest("/api/v1/brands/all");
  return body.data;
}

function appendCategoryIds(params, categoryIds) {
  if (!Array.isArray(categoryIds)) return;
  categoryIds.forEach((id) => {
    if (id != null) params.append("categoryIds", String(id));
  });
}

export async function createBrand({ name, logoUrl, displayOrder, categoryIds }) {
  const params = new URLSearchParams({ name, logoUrl });
  if (displayOrder != null) params.set("displayOrder", displayOrder);
  appendCategoryIds(params, categoryIds);
  const body = await apiRequest(`/api/v1/brands?${params}`, { method: "POST" });
  return body.data;
}

export async function updateBrand({ brandId, name, logoUrl, displayOrder, categoryIds }) {
  const params = new URLSearchParams({ brandId, name, logoUrl });
  if (displayOrder != null) params.set("displayOrder", displayOrder);
  if (Array.isArray(categoryIds) && categoryIds.length === 0) {
    params.set("clearCategories", "true");
  } else {
    appendCategoryIds(params, categoryIds);
  }
  const body = await apiRequest(`/api/v1/brands?${params}`, { method: "PUT" });
  return body.data;
}

export async function toggleBrandStatus(brandId) {
  await apiRequest(`/api/v1/brands/toggle/status?brandId=${brandId}`, { method: "PUT" });
}
